import styled from 'styled-components'

export const GlobalCommandOrgCategoriesFormStyled = styled.div`
  padding: ${(props) => props.theme.space.large};
  border-radius: ${(props) => props.theme.typography.pxToRem(8)};
  background-color: ${(props) => props.theme.colors.offwhite};
`
